$(function() {

    var $cao = $('.js-cao-container');
    var $cao_name = $cao.find('.js-cao-name');
    var $cao_photo = $cao.find('.js-cao-photo');
    var $cao_chat = $cao.find('.js-cao-chat');
    var $cao_text = $cao.find('.js-cao-text');
    var $photo_src = $cao_photo.attr('src');


    var lazyLoadCaoImages = function(options) {
        
        $cao.find('img').each(function() {
            var $icon = $(this);
            
            if (options && options.altButtonSrc && !$icon.hasClass('js-cao-photo')) {
                $icon.attr('src', $icon.attr('data-altsrc'));
            }
            else {
                $icon.attr('src', $icon.attr('data-src'));
            }
        });
        
    };


    var showCAO = function() {
        $cao.removeClass('is-hidden');
    };
    
    
    var hideCAO = function() {
        $cao.addClass('is-hidden');
    };


    var addCaoListeners = function() {
        
        $cao_chat.on('click', function(e) {
            acquireIO.max();
            dataLayer.push({'event': 'chatClicked'});
        });

        $cao_text.on('click', function(e) {
            dataLayer.push({'event': 'textClicked'});
        });
        
    };


    var isCorpUser = function() {
        
        var c = document.cookie.split('; ');
        var cookies = {};

        for (var i = c.length-1; i >= 0; i--){
           var C = c[i].split('=');
           cookies[C[0]] = C[1];
        }

        if (!cookies['tbcorporate'] || cookies['tbcorporate'] !== '1') {
            
            return false;
        } 
        else {
            return true;
            
        }
    };
    
    
    var insertCao = function(options) {
        
        var is_corp_user = isCorpUser();
        var has_override = /showosc=y/.test(window.location.search);
        
        if (!is_corp_user || has_override) {
            var $body = $('body');
            $body.addClass('osc-is-online')
            
            if (options && options.inject) {
                
                var $container = $(options.inject);
                if (toll.getMediaMatch(options.injectBreakpoint)) $container.append($cao);
                
                $(window).resize(function(){
                    if (toll.getMediaMatch(options.injectBreakpoint)) {
                        $container.append($cao);
                    }
                    else {
                        $body.append($cao);
                    }
                });
            }

            showCAO();
            lazyLoadCaoImages(options);
            addCaoListeners();
            
        }
    };
    

    var cleanAgentData = function(agents) {
        
        var agent = agents[Math.floor(Math.random() * agents.length)];  //pick random agent
        var name = agent.name;
        
        if (name) {
            
            var split = name.split(' ');

            if (split && split.length > 1) {
                agent['firstName'] = split[0];
                agent['lastName'] = split[split.length - 1];
            }
            else {
                agent['firstName'] = name;
                agent['lastName'] = '';    
            }

        }
        
        return agent;
        
    };
    
    
    var handleAgentStatus = function(data, options) {
        
        var agent = {};

        if (data.status === 'online' && data.data && data.data.length > 0) {
            agent = cleanAgentData(data.data);
        }
        else {
            return;
        }

        $cao_photo.attr('data-src', agent.photo);

        if (options && options.name) {
            $cao_name.html('<span class="cao-heading">Online Concierge</span>' + agent.name);
        }
        else {
            $cao_name.html(agent.firstName +  ' is Online');
        }
        
        acquire.push({
            userDetails:{
               name: '',
               email: '',
               fields : { 
                    jde : toll.caoId
               }
            }
        });

        acquire.push(function (app){  
            acquireIO.min();

            acquire.push({
                init_department: toll.acquireId + ''
            });

            insertCao(options);
            
        });

    };
    
    
    var initCao = function(options) {
        
        if (toll.caoId && toll.caoId !== '' && toll.acquireId && toll.acquireId !== '') {

            toll.caoId = toll.caoId + '';
            toll.acquireId = toll.acquireId + '';
            
            $.ajax({
                dataType: "jsonp",
                url: 'https://www.tollbrothers.com/api/acquireio?acquireId=' + toll.acquireId,
                success: function (data) {
                    handleAgentStatus(data, options);
                }

            });
            
        }
        
    };

    toll.caoController = {
        init : initCao
    };

    initCao();
    
    if ($photo_src != ' ') {
        setTimeout(function(){
            $cao.addClass('loaded');
        },700);        
    } 
    
});


